import React from 'react'
import { SearchProvider, WithSearch } from '@elastic/react-search-ui'

// import SiteSearchAPIConnector from '@elastic/search-ui-site-search-connector'
// for now, using our version of the connector that exposes the raw result
// search-ui will update to support this in the future
import SiteSearchAPIConnector from '../../lib/SiteSearchConnector'

import STVSearchbox from './STVSearchbox'
// eslint-disable-next-line import/no-named-as-default
import STVResults from './STVResults'

const siteSearchQuery = {
  per_page: 100,
}

const connector = new SiteSearchAPIConnector({
  documentType: 'page',
  engineKey: 'S1jgssBHdk8ZtMWngK_y',
  beforeSearchCall: (queryOptions, next) => {
    const withOptions = {
      ...queryOptions,
      ...siteSearchQuery,
      spelling: 'strict',
    }
    return next(withOptions)
  },
  beforeAutocompleteResultsCall: (queryOptions, next) => {
    const withOptions = {
      ...queryOptions,
      ...siteSearchQuery,
    }
    return next(withOptions)
  },
})

const configurationOptions = {
  apiConnector: connector,
  searchQuery: {
    search_fields: {
      // adjusting weight of title in search results
      'title^3': {},
      body: {},
      category: '',
      sections: [],
    },
    result_fields: {
      title: {
        snippet: {
          size: 100,
          fallback: true,
        },
      },
      body: {},
      resultDescriptionTx: {},
      url: {},
      image: {},
      customImage: {},
      category: [],
      tvGuideDate: '',
    },
  },
  hasA11yNotifications: true,
  a11yNotificationMessages: {
    searchResults: ({
      start, end, totalResults, searchTerm,
      // eslint-disable-next-line max-len
    }) => `Searching for "${searchTerm}". Showing ${start} to ${end} results out of ${totalResults}.`,
  },
  alwaysSearchOnInitialLoad: false,
  trackUrlState: false,
}

const SwiftypeSearch = () => (
  <SearchProvider config={configurationOptions} style={{ position: 'relative', zIndex: 5 }}>
    <STVSearchbox showButton />
    <WithSearch mapContextToProps={({ results }) => (results)}>
      {results => Object.keys(results).length > 0 && <STVResults />}
    </WithSearch>
  </SearchProvider>
)

export default SwiftypeSearch
